import * as React from 'react';
import { SVGProps } from 'react';

const IconLogicalElementSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 2v2h2v4H1v2h4a4.002 4.002 0 0 0 3.874-3H11V5H8.874A4.002 4.002 0 0 0 5 2H1z" />
  </svg>
);
export default IconLogicalElementSizeXs;
